// Author Liu Cui Cui
// Date 2023-10-12 08:12:43

class SithMesTpmOperateModeTom {
constructor({
        id = null,
        tomOperatorId = '',
        tomOperatorName = '',
        tomProgramName = '',
        tomOperateSeq = '',
        tomLocationId = '',
        tomStartTime = '',
        tomEndTime = '',
        tomDuration = '',
        tomOperateMode = '',
        tomDeviceCode = '',
        tomDeviceSystemType = '',
        remark = ''}
= {}) {
    this.id = id;
    this.tomOperatorId = tomOperatorId;
    this.tomOperatorName = tomOperatorName;
    this.tomProgramName = tomProgramName;
    this.tomOperateSeq = tomOperateSeq;
    this.tomLocationId = tomLocationId;
    this.tomStartTime = tomStartTime;
    this.tomEndTime = tomEndTime;
    this.tomDuration = tomDuration;
    this.tomOperateMode = tomOperateMode;
    this.tomDeviceCode = tomDeviceCode;
    this.tomDeviceSystemType = tomDeviceSystemType;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesTpmOperateModeTom();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tomOperatorName',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.grid.tomOperatorName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tomDeptName',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.grid.tomDeptName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tomProjectCode',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.grid.tomProjectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tomItemName',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.grid.tomItemName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tomProgramName',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.grid.tomProgramName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tomOrderCode',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.grid.tomOrderCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'prdPpOperationName',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.grid.prdPpOperationName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tomMstLocName',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.grid.tomMstLocName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tomStartTime',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.grid.tomStartTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tomEndTime',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.grid.tomEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tomDuration',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.grid.tomDuration',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tomOperateMode',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.grid.tomOperateMode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tomDeviceCode',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.grid.tomDeviceCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tomDeviceSystemType',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.grid.tomDeviceSystemType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    tomOperatorIdFilter : '',
    tomOperatorNameFilter : '',
    tomDeptNameFilter : '',
    tomProjectCodeFilter : '',
    tomItemNameFilter : '',
    tomProgramNameFilter : '',
    tomOrderCodeFilter : '',
    tomOperateSeqFilter : '',
    prdPpOperationNameFilter : '',
    tomLocationIdFilter : '',
    tomMstLocNameFilter : '',
    tomStartTimeRteFilter : '',
    tomStartTimeLteFilter : '',
    tomEndTimeRteFilter : '',
    tomEndTimeLteFilter : '',
    tomDurationFilter : '',
    tomDurationGreaterFilter : '',
    tomOperateModeFilter : '',
    tomDeviceCodeFilter : '',
    tomDeviceSystemTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'tomOperatorIdFilter',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.filter.tomOperatorId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'tomOperatorNameFilter',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.filter.tomOperatorName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomDeptNameFilter',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.filter.tomDeptName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomProjectCodeFilter',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.filter.tomProjectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomItemNameFilter',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.filter.tomItemName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomProgramNameFilter',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.filter.tomProgramName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomOrderCodeFilter',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.filter.tomOrderCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'prdPpOperationNameFilter',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.filter.prdPpOperationName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomMstLocNameFilter',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.filter.tomMstLocName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomStartTimeRteFilter',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.filter.tomStartTimeRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomStartTimeLteFilter',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.filter.tomStartTimeLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomEndTimeRteFilter',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.filter.tomEndTimeRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomEndTimeLteFilter',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.filter.tomEndTimeLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomDurationFilter',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.filter.tomDuration',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomDurationGreaterFilter',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.filter.tomDurationGreater',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomOperateModeFilter',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.filter.tomOperateMode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomDeviceCodeFilter',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.filter.tomDeviceCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomDeviceSystemTypeFilter',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.filter.tomDeviceSystemType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'tomOperatorName',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.entity.tomOperatorName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"tomOperatorId":"id"}'
                }
        },
        {
        key: 'tomProgramName',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.entity.tomProgramName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomOperateSeq',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.entity.tomOperateSeq',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesPrdPpOperation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'tomLocationId',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.entity.tomLocationId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'tomStartTime',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.entity.tomStartTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomEndTime',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.entity.tomEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomDuration',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.entity.tomDuration',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomOperateMode',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.entity.tomOperateMode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomDeviceCode',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.entity.tomDeviceCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tomDeviceSystemType',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.entity.tomDeviceSystemType',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.tpm.sithMesTpmOperateModeTom.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesTpmOperateModeTom, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
